import { useEffect } from "react";
import { sendPageViewEvent } from "../services/analytics";

const usePageViews = (location) => {
	const pathname = location.pathname;
	console.log(`redirecting to - ${Date.now()}`, pathname);
	useEffect(() => {
		let parentStoreUrl = window.location.hostname;

		// /setup --> Setup ~~~ /setup/facebook --> Facebook
		let titleFromRoute = pathname.split("/");
		titleFromRoute = titleFromRoute[titleFromRoute.length - 1];
		if (titleFromRoute) {
			titleFromRoute = titleFromRoute[0].toUpperCase() + titleFromRoute.substring(1).toLowerCase();

			sendPageViewEvent({
				page_title: titleFromRoute,
				page_location: parentStoreUrl,
				page_path: pathname
			});
		}
	}, [location]);
};

export default usePageViews;
